module.exports = __webpack_public_path__ + "6fb7614a7e8bb30fc4e63e520580cfc7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/denis-rechkunov.jpg
 ** module id = 409
 ** module chunks = 0
 **/